var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle2, _path14, _rect, _rect2, _polygon, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.8 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Circle with Verify Document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "verifyCircleBkg",
    cx: 30,
    cy: 30.072,
    r: 25.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m33.4 58.1c-0.1-0.8 0.4-1.6 1.2-1.7 0.8-0.2 1.6 0.4 1.7 1.2s-0.4 1.6-1.2 1.7h-0.3c-0.6 0.1-1.2-0.4-1.4-1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m22.6 58.9c-0.8-0.2-1.3-1-1.1-1.8s1-1.3 1.8-1.1 1.3 1 1.1 1.8c-0.2 0.7-0.8 1.1-1.4 1.1h-0.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m44.7 54.2c-0.5-0.7-0.3-1.6 0.4-2.1s1.6-0.3 2.1 0.4 0.3 1.6-0.4 2.1c-0.3 0.2-0.6 0.3-0.9 0.3-0.4 0-0.9-0.2-1.2-0.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m11.4 53.3c-0.6-0.5-0.8-1.5-0.2-2.1 0.5-0.7 1.5-0.8 2.1-0.2 0.6 0.5 0.8 1.5 0.2 2.1-0.3 0.4-0.7 0.6-1.2 0.6-0.3-0.1-0.6-0.2-0.9-0.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m53.4 46c-0.7-0.4-0.9-1.4-0.5-2.1s1.4-0.9 2.1-0.5 0.9 1.3 0.5 2.1c-0.3 0.5-0.8 0.7-1.3 0.7-0.3 0.1-0.6 0-0.8-0.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m3.5 43.6c-0.4-0.7-0.1-1.6 0.6-2s1.6-0.1 2 0.7c0.4 0.7 0.1 1.6-0.6 2-0.2 0.1-0.5 0.2-0.7 0.2-0.5-0.1-1.1-0.4-1.3-0.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m57.9 35c-0.8-0.1-1.4-0.9-1.3-1.7s0.9-1.4 1.7-1.3 1.4 0.9 1.3 1.7-0.7 1.3-1.5 1.3h-0.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m0.2 31.5c0-0.8 0.6-1.5 1.4-1.6 0.8 0 1.5 0.6 1.6 1.4 0 0.8-0.6 1.5-1.4 1.6h-0.1c-0.8 0-1.4-0.6-1.5-1.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m55.6 22.1c-0.2-0.8 0.2-1.6 1-1.9 0.8-0.2 1.6 0.2 1.9 1 0.2 0.8-0.2 1.6-1 1.9-0.2 0.1-0.3 0.1-0.4 0.1-0.7 0-1.3-0.5-1.5-1.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m3.1 21c-0.8-0.3-1.1-1.2-0.8-1.9 0.3-0.8 1.2-1.1 1.9-0.9 0.8 0.3 1.1 1.2 0.8 2-0.2 0.6-0.8 1-1.4 1-0.1 0-0.3-0.1-0.5-0.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m50.1 12.3c-0.5-0.6-0.5-1.6 0.1-2.1s1.6-0.5 2.1 0.1 0.5 1.6-0.1 2.1c-0.3 0.2-0.6 0.4-1 0.4s-0.8-0.2-1.1-0.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m9.2 10.8c-0.6-0.6-0.6-1.6 0-2.1 0.6-0.6 1.5-0.6 2.1 0s0.6 1.5 0 2.1c-0.3 0.3-0.7 0.4-1.1 0.4s-0.7-0.1-1-0.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m41 5.6c-0.8-0.4-1.1-1.2-0.7-2 0.3-0.8 1.2-1.1 2-0.8s1.1 1.2 0.8 2c-0.2 0.6-0.8 0.9-1.4 0.9-0.3 0-0.5 0-0.7-0.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m18.9 3.9c-0.3-0.8 0.1-1.6 0.9-1.9s1.6 0.1 1.9 0.9-0.1 1.6-0.9 1.9c-0.2 0.1-0.3 0.1-0.5 0.1-0.6 0-1.2-0.4-1.4-1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m28.5 1.7c0-0.8 0.7-1.5 1.5-1.5s1.5 0.7 1.5 1.5-0.7 1.5-1.5 1.5-1.5-0.7-1.5-1.5z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "verifyCircleGreen",
    cx: 37.3,
    cy: 39.5,
    r: 4.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m32.7 40.9c-0.5 0.1-1 0.2-1.5 0.2h-9.8v-21.6h16.1v15.2c0.4 0 0.8 0.1 1.2 0.2v-16.5h-18.5v23.9h11c0.7 0 1.4-0.1 2-0.3-0.2-0.3-0.3-0.7-0.5-1.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "verifyIconOutline",
    x: 26.4,
    y: 36.9,
    width: 4.8,
    height: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "verifyIconOutline",
    x: 26.4,
    y: 34.1,
    width: 6.8,
    height: 0.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "verifyCheckmark",
    points: "40.2 37.2 39.6 36.8 37.1 41.1 35 39 34.4 39.6 37.3 42.3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m29.786 22.7c-2.5112 0-4.5658 2.0546-4.5658 4.5658s2.0546 4.5658 4.5658 4.5658 4.5658-2.0546 4.5658-4.5658-2.0546-4.5658-4.5658-4.5658m0 0.3805c2.3019 0 4.1853 1.8834 4.1853 4.1853 0 0.9322-0.3044 1.7883-0.818 2.4732-0.1332-0.4566-0.5137-0.818-1.0844-1.0083l-2.2829-0.4185-2.2639 0.4185c-0.5707 0.1522-0.9893 0.5327-1.1224 1.0083-0.4946-0.6849-0.799-1.541-0.799-2.4732 0-2.3019 1.8834-4.1853 4.1853-4.1853m0 8.3707c-1.1985 0-2.2829-0.5137-3.0439-1.3127v-0.038c0-0.5707 0.4566-0.8751 0.8751-0.9893l2.1688-0.4185 2.1688 0.3995c0.2663 0.0951 0.8751 0.3424 0.8751 0.9893v0.0571c-0.761 0.7989-1.8454 1.3126-3.0439 1.3126"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "verifyIconOutline",
    d: "m28.416 26.296c0.1522 0.818 0.6849 1.3507 1.3697 1.3507 0.6849 0 1.2176-0.5137 1.3697-1.3507 0.019-0.1332 0.1522-0.761 0.1522-0.9132 0.019-0.3995-0.1332-0.78-0.3995-1.0654-0.2854-0.3044-0.7039-0.4756-1.1224-0.4756s-0.8371 0.1712-1.1224 0.4756c-0.2663 0.2854-0.4185 0.6658-0.3995 1.0654 0.019 0.1522 0.1331 0.8371 0.1522 0.9132m0.5136-1.7122c0.2283-0.2283 0.5327-0.3615 0.8561-0.3615s0.6278 0.1332 0.8371 0.3615c0.2093 0.2093 0.3044 0.4946 0.3044 0.78 0 0.0951-0.0951 0.5898-0.1522 0.8751-0.0951 0.4946-0.3995 1.0273-0.9893 1.0273s-0.9132-0.5517-0.9893-1.0273c-0.0571-0.2854-0.1332-0.761-0.1522-0.8751-0.019-0.2854 0.0952-0.5707 0.2854-0.78"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationCircle);
export default __webpack_public_path__ + "static/media/verification-circle.767dcee27bb50248b2efd3fe49997364.svg";
export { ForwardRef as ReactComponent };